import { useEffect, useRef } from 'react';

/**
 * Dispara `revalidate` quando a aba/janela volta a ficar visível após ter
 * ficado em segundo plano. Ignora o focus inicial da montagem.
 */
export function useRevalidateOnFocus(revalidate: () => void, enabled = true): void {
  const revalidateRef = useRef(revalidate);
  revalidateRef.current = revalidate;

  useEffect(() => {
    if (!enabled || typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }

    let wasHidden = document.visibilityState === 'hidden';

    function run() {
      if (document.visibilityState !== 'visible' || !wasHidden) return;
      wasHidden = false;
      revalidateRef.current();
    }

    function onVisibilityChange() {
      if (document.visibilityState === 'hidden') {
        wasHidden = true;
        return;
      }
      run();
    }

    function onWindowFocus() {
      run();
    }

    document.addEventListener('visibilitychange', onVisibilityChange);
    window.addEventListener('focus', onWindowFocus);

    return () => {
      document.removeEventListener('visibilitychange', onVisibilityChange);
      window.removeEventListener('focus', onWindowFocus);
    };
  }, [enabled]);
}
